import { SidebarInset, SidebarProvider } from "@/shared/components/ui/sidebar";
import { SettingSidebar } from "./setting-sidebar";
import { useEffect } from "react";
import authService from "@/shared/services/api/auth-service";
import { setMe } from "@/core/redux/slices/user";
import { useDispatch } from "react-redux";

export default function SettingLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const dispatch = useDispatch();
  const getUserMe = async () => {
    const response = await authService.getMe();

    if (response.success) {
      dispatch(setMe(response.data.user));
    }
  };
  useEffect(() => {
    getUserMe();
  }, []);
  return (
    <SidebarProvider>
      <SettingSidebar />
      <SidebarInset className="border border-[#E4E4E7]">
        {/* <header className="flex h-16 shrink-0 items-center gap-2">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem className="breadcrumb-item hidden md:block text-sm leading-5 ">
                  <BreadcrumbLink href="#">{t("settings")}</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="breadcrumb-separator  " />
                <BreadcrumbItem>
                  <BreadcrumbPage></BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </header> */}
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0">{children}</div>
      </SidebarInset>
    </SidebarProvider>
  );
}
